import Cookies from 'js-cookie';

// Token được lưu ở localStorage thay vì cookie: cookie bị trình duyệt gửi kèm
// mọi request nên JWT của SSO (rất dài, có chứa ssoIdToken) làm request header
// vượt quá maxHttpHeaderSize của Tomcat -> HTTP 400 "Request header is too large".
const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY) || undefined;

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY) || undefined;

export const setTokens = (accessToken, refreshToken) => {
  if (accessToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  }
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
  removeLegacyTokenCookies();
};

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  removeLegacyTokenCookies();
};

// Người dùng đã đăng nhập trước khi deploy bản này vẫn chỉ có token ở cookie.
// Chuyển sang localStorage rồi xoá cookie để họ không bị đá ra màn hình đăng nhập.
export const migrateLegacyTokenCookies = () => {
  const cookieAccessToken = Cookies.get(ACCESS_TOKEN_KEY);
  const cookieRefreshToken = Cookies.get(REFRESH_TOKEN_KEY);
  if (cookieAccessToken && !localStorage.getItem(ACCESS_TOKEN_KEY)) {
    localStorage.setItem(ACCESS_TOKEN_KEY, cookieAccessToken);
  }
  if (cookieRefreshToken && !localStorage.getItem(REFRESH_TOKEN_KEY)) {
    localStorage.setItem(REFRESH_TOKEN_KEY, cookieRefreshToken);
  }
  removeLegacyTokenCookies();
};

// Xoá cookie token cũ còn sót lại ở các phiên đăng nhập trước khi đổi sang
// localStorage, tránh việc header vẫn phình to sau khi deploy bản mới.
export const removeLegacyTokenCookies = () => {
  Cookies.remove(ACCESS_TOKEN_KEY);
  Cookies.remove(REFRESH_TOKEN_KEY);
  Cookies.remove(ACCESS_TOKEN_KEY, { path: '/' });
  Cookies.remove(REFRESH_TOKEN_KEY, { path: '/' });
};
